import { z } from 'zod';

import {
  AUTOCOMPLETE_ERROR,
  INCORRECT_FORMAT_MESSAGE,
  MONEY_REGEX,
  OWNS_HOME_ERROR_MESSAGE,
  REQUIRED_FIELD_MESSAGE,
  ZIP_REGEX,
} from './constants';

export enum InputName {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  FULL_NAME = 'fullName',
  EMAIL = 'email',
  ZIP_CODE = 'zipCode',
  PHONE = 'phone',
  TCPA_ACKNOWLEDGMENT = 'tcpaAcknowledgment',
  OWN_HOME = 'ownHome',
  LAST_BILL = 'lastBill',
  UTILITY = 'utility',
  REFERRED = 'referred',
  AUTOCOMPLETE_ADDRESS = 'autocomplete_address',
  ADDRESS = 'address',
}

// TODO: PXE-2436, move this to a better place
export enum OwnHome {
  OWN = 'OWN',
  RENT = 'RENT',
}

export const nonEmptyStringValidator = z
  .string()
  .trim()
  .nonempty(REQUIRED_FIELD_MESSAGE);
export const firstNameValidator = {
  [InputName.FIRST_NAME]: nonEmptyStringValidator,
};
export const lastNameValidator = {
  [InputName.LAST_NAME]: nonEmptyStringValidator,
};
export const billAmountsValidator = {
  [InputName.LAST_BILL]: nonEmptyStringValidator,
};

export {
  emailValidator,
  fullNameValidator,
  phoneValidator,
} from '@packages/shared-ui/validation';

export const zipCodeValidator = {
  [InputName.ZIP_CODE]: nonEmptyStringValidator.regex(
    ZIP_REGEX,
    INCORRECT_FORMAT_MESSAGE('zip code')
  ),
};

export const autocompleteAddressValidator = {
  [InputName.AUTOCOMPLETE_ADDRESS]: z.string().nonempty(AUTOCOMPLETE_ERROR),
};

export const utilDropdownValidator = {
  [InputName.UTILITY]: nonEmptyStringValidator,
};

export const referredValidator = {
  [InputName.REFERRED]: z.boolean({ message: REQUIRED_FIELD_MESSAGE }),
};
export const ownHomeValidator = {
  [InputName.OWN_HOME]: z.enum(OwnHome, {
    error: REQUIRED_FIELD_MESSAGE,
  }),
};

export const ownHomeRadioValidator = {
  [InputName.OWN_HOME]: ownHomeValidator[InputName.OWN_HOME].superRefine(
    (val, ctx) => {
      if (val !== OwnHome.OWN) {
        ctx.addIssue({
          code: 'custom',
          message: OWNS_HOME_ERROR_MESSAGE,
        });
      }
    }
  ),
};

export const booleanIsTrueValidator = {
  [InputName.OWN_HOME]: z.literal(true, {
    message: OWNS_HOME_ERROR_MESSAGE,
  }),
};

export const lastBillValidator = {
  [InputName.LAST_BILL]: nonEmptyStringValidator
    .regex(MONEY_REGEX, INCORRECT_FORMAT_MESSAGE('bill amount'))
    .refine(
      // biome-ignore lint/correctness/useParseIntRadix: Automated migration to Biome
      (val) => parseInt(val) >= 1,
      INCORRECT_FORMAT_MESSAGE('bill amount')
    ),
};

export const honeypotAddressFieldValidator = {
  [InputName.ADDRESS]: z.string().optional(),
};
